//申请预约相关接口
import request from '../utils/axios'

// 获取列表（工作人员）
export function GetLis(params) {
  return request({
    url: "/Ordered/GetLis",
    method: 'post',
		data:params
  })
}

// 获取预约详情（工作人员）
export function GetDetaile(id) {
  return request({
    url: `/Ordered/GetDetaile?id=${id}`,
    method: 'get',
  })
}

// 获取预约详情（设计公司/普通用户）
export function GetDetaile2(id) {
  return request({
    url: `/Ordered/GetDetaile2?id=${id}`,
    method: 'get',
  })
}

// 添加预约
export function Add(params) {
  return request({
    url: "/Ordered/Add",
    method: 'post',
		data:params
  })
}

// 添加预约(设计公司/普通用户)
export function Add2(params) {
  return request({
    url: "/Ordered/Add2",
    method: 'post',
		data:params
  })
}

// 修改预约信息(工作人员)
export function Update(params) {
  return request({
    url: "/Ordered/Update",
    method: 'post',
		data:params
  })
}

// 审核预约信息
export function Examine(params) {
  return request({
    url: "/Ordered/Examine",
    method: 'post',
		data:params
  })
}

// 获取图形数据（工作人员）
export function GetShps(data) {
  return request({
    url: `/CutLicense/GetShps?id=${data.id}&type=${data.type}`,
    method: "get"
  })
}

// 获取所有预约图层(工作人员)
export function GetAllOrderedGeo() {
  return request({
    url: '/Ordered/GetAllOrderedGeo',
    method: 'get',
  })
}

// 获取审批管理模块统计(工作人员)
export function GetSpglCount() {
  return request({
    url: '/Ordered/GetSpglCount',
    method: 'get',
  })
}

// 获取导航栏提示标志(工作人员)
export function GetPromptFlags() {
  return request({
    url: '/Ordered/GetPromptFlags',
    method: 'get',
  })
}

// 获取审批统计数量(工作人员)
export function GetApprovalCount() {
  return request({
    url: '/Ordered/GetApprovalCount',
    method: 'get',
  })
}

// 获取审批统计图(工作人员)
export function GetApprovalChart(params) {
  return request({
    url: "/Ordered/GetApprovalChart",
    method: 'post',
		data:params
  })
}

//  删除预约(工作人员)
export function Delete(id) {
  return request({
    url: `/Ordered/Delete?id=${id}`,
    method: "get"
  })
}